import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Spinner } from '../components/ui/Spinner';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';

export function VerifyPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('No verification token found. Please request a new magic link.');
      return;
    }

    // Redirect the browser to the API verification endpoint.
    // The backend will validate the token, set the session cookie, and redirect to /.
    window.location.href = `/api/auth/verify?token=${encodeURIComponent(token)}`;
  }, [searchParams]);

  if (error) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-card__brand">
            <span className="auth-card__logo">
              Histo<em>Ryjki</em>
            </span>
          </div>
          <div className="auth-card__status">
            <Badge variant="danger">Verification Failed</Badge>
            <p className="auth-card__status-message">{error}</p>
            <Button variant="accent" onClick={() => navigate('/login', { replace: true })}>
              Back to Login
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-card__brand">
          <span className="auth-card__logo">
            Histo<em>Ryjki</em>
          </span>
        </div>
        <div className="auth-card__status">
          <Spinner size="lg" />
          <p className="auth-card__status-message">Verifying your login…</p>
        </div>
      </div>
    </div>
  );
}
